import StatusBadge from "@/components/shared/StatusBadge";
import { FEEDBACK_STATUS_COLOR, FEEDBACK_STATUS_LABEL, FEEDBACK_TYPE_LABEL } from "@/config/dropdownData";

import FeedbackDateCell from "./FeedbackDateCell";

// A tenant's feedback as its users see it on "My Feedback". A tenant admin
// sees the whole organisation's there, with SENT_BY after the first column.
export const FEEDBACK_COLUMNS = [
  {
    key: "created_at",
    label: "Sent",
    sortable: false,
    align: "left",
    render: (val, row) => <FeedbackDateCell date={val} imported={row.is_imported} />,
  },
  {
    key: "type",
    label: "Type",
    sortable: false,
    align: "left",
    render: (val) => <span className="text-[13px]">{FEEDBACK_TYPE_LABEL[val] ?? val}</span>,
  },
  {
    key: "comment",
    label: "Comment",
    sortable: false,
    align: "left",
    render: (val) => (
      <span className="block max-w-[320px] overflow-hidden text-ellipsis whitespace-nowrap text-[13px]" title={val}>
        {val}
      </span>
    ),
  },
  {
    key: "status",
    label: "Status",
    sortable: false,
    align: "center",
    // Appreciation is never worked and holds no status: it shows none.
    render: (val) => (
      <div className="flex justify-center">
        {val ? (
          <StatusBadge text={FEEDBACK_STATUS_LABEL[val] ?? val} colorIndex={FEEDBACK_STATUS_COLOR[val] ?? 0} size="sm" />
        ) : (
          <span className="text-[12px] text-text-secondary">—</span>
        )}
      </div>
    ),
  },
  {
    // The team's closing words — present once the feedback has ended, and the
    // same words the submitter was emailed.
    key: "end_reason",
    label: "Response",
    sortable: false,
    align: "left",
    render: (val, row) =>
      row.ended && val ? (
        // One line, as Comment is; the full words are on hover and in the view.
        <span className="block max-w-[320px] overflow-hidden text-ellipsis whitespace-nowrap text-[13px]" title={val}>
          {val}
        </span>
      ) : (
        // Nothing until the team has written a response, by decision: the
        // status already says where it stands.
        <span className="text-[12px] text-text-secondary">—</span>
      ),
  },
];

// Who sent it, for the tenant admin: name and email, both null once that user
// no longer exists.
export const SENT_BY_COLUMN = {
  key: "submitter_name",
  label: "Sent by",
  sortable: false,
  align: "left",
  render: (val, row) =>
    val ? (
      <div className="flex flex-col">
        <span className="text-[13px]">{val}</span>
        {row.submitter_email && <span className="text-[12px] text-text-secondary">{row.submitter_email}</span>}
      </div>
    ) : (
      <span className="text-[12px] text-text-secondary">Removed user</span>
    ),
};
